<template lang="pug">
div
  v-runtime-template(v-if="accommodationsList" :template="accommodationsList")
  div(v-else)
    slot
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import AccommodationsSearch from "@utils/accommodations-search"

export default {
  components: {
    VRuntimeTemplate
  },

  data () {
    return {
      accommodationsSearch: null
    }
  },

  computed: {
    accommodationsList () {
      return this.$store.getters.getAccommodationsList
    }
  },

  watch: {
    accommodationsList: {
      immediate: true,
      handler () {
        if (this.accommodationsSearch) this.accommodationsSearch.destroy()
        this.accommodationsSearch = new AccommodationsSearch()
      }
    }
  }
}
</script>
